var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-between bg-gray-200 w-3/4 md:w-1/3 min-h-5 mb-3 rounded py-3 px-5",class:{
    'ml-auto mr-0 bg-blue-100': _vm.message.fromMe,
  }},[_c('span',{staticClass:"break-words pr-5"},[_vm._v(_vm._s(_vm.message.message))]),_c('span',{staticClass:"text-gray-400"},[_vm._v(_vm._s(_vm.timestamp))])])}
var staticRenderFns = []

export { render, staticRenderFns }